import { createSlice } from '@reduxjs/toolkit';
import { reHydrateStore } from '../utils/local-storage';

const initialState = null;

const slice = createSlice({
  name: 'promotions',
  initialState: reHydrateStore('promotions') || initialState,
  reducers: {
    setPromotion: (state, { payload }) => ({ ...payload }),
    setPromotionCode: (state, { payload }) => payload,
    setPromotionError: (state, { payload }) => ({
      ...state,
      error: payload,
    }),
    restoreError: (state) => {
      const { error, ...restState } = state;
      const propertiesQty = Object.keys(restState).length;
      return propertiesQty > 0 ? { ...restState } : initialState;
    },
    restore: () => initialState,
  },
});

export const { setPromotion, setPromotionCode, setPromotionError, restoreError, restore } =
  slice.actions;

export default slice.reducer;
